app.controller("ReceivedPollsController", ["$scope", "$stateParams", "$uibModal", "$state", "PollService", "$rootScope", "usSpinnerService",
    function ($scope, $stateParams, $uibModal, $state, PollService, $rootScope, usSpinnerService) {
        $scope.polls = null;
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.activeTab = 0;

        loadPage($stateParams.page, $scope.query, function () {
            $scope.currentPage = $stateParams.page;
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $scope.mark = function (poll) {
            PollService.mark({
                poll: poll,
                state: 'read'
            });
        };

        $scope.open = function (item) {
            $uibModal.open({
                controller: "PollsWindowController",
                templateUrl: _pb + 'admin/polls/poll-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {info: item, poll: item.poll};
                    }
                }
            }).result
                .then(function (result) {
                    if (!result && item.state === 'unread') $scope.mark(item._id);
                    loadPage();
                    $rootScope.$broadcast('pollCount', {});
                }, function () {
                    if (item.state === 'unread') $scope.mark(item._id);
                    loadPage();
                    $rootScope.$broadcast('pollCount', {});
                });
        };

        function loadPage(page, query, cb) {
            cb = cb || function () {
                };
            usSpinnerService.spin("root");
            PollService.received({
                page: page,
                query: query,
                limit: $scope.itemsPerPage
            }).then(function (data) {
                $scope.polls = data.docs;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb();
            });
        }

        $scope.$on('loadPage', function (event, args) {
            loadPage($stateParams.page, $scope.query);
        });

        $scope.create = function () {
            $state.go("admin.createNotifications", {});
        };
    }
]);
